import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { RouteLoading } from "@/components/RouteLoading";

const CoursesHubPage = lazy(() => import("@/components/courses/CoursesHubPage"));

export const Route = createFileRoute("/_authenticated/courses")({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      id: search.id as string | undefined,
    };
  },
  component: CoursesRoute,
});

function CoursesRoute() {
  return (
    <Suspense fallback={<RouteLoading label="Loading courses..." />}>
      <CoursesHubPage />
    </Suspense>
  );
}
